import { render, staticRenderFns } from "./ContactChannelCheckbox.vue?vue&type=template&id=e6a7c852&"
import script from "./ContactChannelCheckbox.vue?vue&type=script&lang=ts&"
export * from "./ContactChannelCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./ContactChannelCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports